var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var OPEN_CHAT_ACTION = 'openChat';
export var isIosChatSupported = function () {
    var supportedNativeActions = window.WH && window.WH.supportedNativeActions;
    return Boolean(supportedNativeActions && supportedNativeActions.indexOf(OPEN_CHAT_ACTION) !== -1);
};
export var isAndroidChatSupported = function () {
    var actionWebInterface = window.ActionWebInterface;
    return Boolean(actionWebInterface &&
        actionWebInterface.supportedActions &&
        actionWebInterface.supportedActions().indexOf(OPEN_CHAT_ACTION) !== -1);
};
var openNativeChat = function () {
    if (isIosChatSupported()) {
        var messageHandlers = window.webkit && window.webkit.messageHandlers;
        var nativeAction = messageHandlers && messageHandlers.doAction;
        if (!nativeAction) {
            throw new Error('iOS native chat action not available');
        }
        nativeAction.postMessage({ name: OPEN_CHAT_ACTION });
        return;
    }
    window.ActionWebInterface.doAction(OPEN_CHAT_ACTION, JSON.stringify({}));
};
var openFallback = function () {
    var fallbackUrl = window.avAppConfig && window.avAppConfig.liveChatLink;
    if (fallbackUrl) {
        window.open(fallbackUrl);
    }
};
export var openLiveMessagingOrNative = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var bootstrapper, liveMessagingClient, error_1;
    var location = _b.location;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                if (isIosChatSupported() || isAndroidChatSupported()) {
                    openNativeChat();
                    return [2];
                }
                bootstrapper = window.WH && window.WH.bootstrapper;
                liveMessagingClient = bootstrapper && bootstrapper.features['live-messaging-flow'];
                if (!liveMessagingClient) {
                    throw new Error('Live Messaging feature not available');
                }
                return [4, liveMessagingClient.openLiveMessaging({ location: location })];
            case 1:
                _c.sent();
                return [3, 3];
            case 2:
                error_1 = _c.sent();
                (window.consoleReference || window.console).error('Failed to open Live Messaging:', error_1);
                openFallback();
                return [3, 3];
            case 3: return [2];
        }
    });
}); };
export var isChatFeatureConfigured = function () {
    return typeof window !== 'undefined' && 'live-messaging-flow' in window.avAppConfig;
};
//# sourceMappingURL=liveMessagingClient.js.map